<template>
  <div @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-3': dragover }">
      <div class="flex flex-col justify-center items-center">
        <div class="block p-10 text-start bg-white">
        <div class="md:mt-2">
          <span class="block mb-6 text-center text-4xl md:text-5xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>{{$t('remove_background_image')}}</strong></span>
        </div>
        <div class="mb-2" dense align="center" justify="center" @click="$refs.file.click()">
              <div>
                <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                  <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                  {{$t('upload_image')}}
                </button>
              </div>
              <div class="mt-2">
                <span v-html="$t('or_drag_and_drop_an_image')" class="block text-center text-x md:text-2x font-bold tracking-tight text-gray-700 dark:text-white"></span>
                <span v-html="$t('or_copy_and_paste_an_image')" class="block text-center text-xs md:text-x font-bold tracking-tight text-gray-700 dark:text-white"></span>
              </div>
              <div class="pb-5 ma-0">
                <span style="font-size:9px; color:#999999" v-html="$t('by_uploading_an_image_you_here_by_agree_to_our')"></span>
                <br>
                <span style="font-size:9px; color:#999999" v-html="$t('this_site_protected_by_recaptcha')"></span>
              </div>
            </div>
        <input type="file" ref="file" hidden @change="onImageSelected"/>
        
        <div class="flex flex-wrap flex-col md:pl-36 md:pr-36 space-y-4">
          <div v-for="item in processedImages.slice().reverse()" :key="item.baseImageFileName">
            <Upload :dialog.sync="uploadDialog" :ref="'upload_' + index" 
            :dragFile="currentDrag" :selectedFile="currentSelected" :loadedImage="item" :toRedirect="false" :index="item.baseImageFileName" 
            @saveImage="saveImage" @updateImage="updateImage" @closeUpload="closeUpload"/>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import Upload from '@/components/Upload.vue';
import FileService from '../services/file.service';

export default {
  name: 'UploadPage',
  components: {
    Upload
  },
  data() {
    return {
      dragover: false,
      uploadDialog:false,
      currentDrag: null,
      currentSelected: null,
      loadedImage: null,
      index:null,
      processedImages: []
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
  },
  mounted() {
    this.loadFromStorage();

    var _this = this;
    this.handler = function(e) {
        e.preventDefault();
        e.stopPropagation();

        _this.onPaste(e.clipboardData);
    };

    window.addEventListener("paste", this.handler,true);
  },
  beforeDestroy() {
    window.removeEventListener("paste", this.handler,true);
  },
  methods: {
    onPaste(e){
      if(e.files.length)
      {
        var file = e.files[0];
        switch (file.type) {
          case 'image/jpeg':
          case 'image/png':
            this.currentSelected = null;
            this.loadedImage = null;
            this.currentDrag = file;

            var emptyImage =
            {
              processedImageUrlOriginal: '',
              processedImageFileNameOriginal: '',
              processedImageUrl: '',
              processedImageFileName: '',
              baseImageUrl: '',
              baseImageFileName: '',
              originalImageData: {
                id: ''
              }
            };

            this.processedImages.push(emptyImage);
          break;
      
        default:
          alert('Only png and jpg are allowed.')
          break;
        }
      }else{
        alert('Only png and jpg are allowed.')
      }
    },

    onDropFromHome(e){
      var file = e;
      switch (file.type) {
        case 'image/jpeg':
        case 'image/png':
          this.currentSelected = null;
          this.loadedImage = null;
          this.currentDrag = file;

          var emptyImage =
          {
            processedImageUrlOriginal: '',
            processedImageFileNameOriginal: '',
            processedImageUrl: '',
            processedImageFileName: '',
            baseImageUrl: '',
            baseImageFileName: '',
            originalImageData: {
              id: ''
            }
          };

          this.processedImages.push(emptyImage);
          break;
      
        default:
          alert('Only png and jpg are allowed.')
          break;
      }
    },

    onDrop(e) {
      this.dragover = false;
      if(e.dataTransfer.files.length)
      {
        var file = e.dataTransfer.files[0];
        switch (file.type) {
          case 'image/jpeg':
          case 'image/png':
            this.currentSelected = null;
            this.loadedImage = null;
            this.currentDrag = file;

            var emptyImage =
            {
              processedImageUrlOriginal: '',
              processedImageFileNameOriginal: '',
              processedImageUrl: '',
              processedImageFileName: '',
              baseImageUrl: '',
              baseImageFileName: '',
              originalImageData: {
                id: ''
              }
            };

            this.processedImages.push(emptyImage);
            break;
        
          default:
            alert('Only png and jpg are allowed.')
            break;
        }
      }else{
        alert('Only png and jpg are allowed.')
      }
    },
    onImageSelected(e) {
      var file = e.target.files[0];
      switch (file.type) {
        case 'image/jpeg':
        case 'image/png':
          this.currentSelected = e;
          this.loadedImage = null;
          this.currentDrag = null;

          var emptyImage =
          {
            processedImageUrlOriginal: '',
            processedImageFileNameOriginal: '',
            processedImageUrl: '',
            processedImageFileName: '',
            baseImageUrl: '',
            baseImageFileName: '',
            originalImageData: {
              id: ''
            }
          };

          this.processedImages.push(emptyImage);

          break;
      
        default:
          alert('Only png and jpg are allowed.')
          break;
      }
    },
    loadFromStorage() {
      try {
        this.processedImagesResponse = JSON.parse(localStorage.getItem('processedImages'));
      } catch(e) {
        localStorage.removeItem('processedImages');
      }

      if(this.processedImagesResponse === null)
      {
        this.processedImages = [];

        if(this.$route.params.method !== undefined)
        {
          if(this.$route.params.selectedFile !== undefined)
          {
              if(this.$route.params.method === 'drop')
                {
                  this.onDropFromHome(this.$route.params.selectedFile);
                }else if(this.$route.params.method === 'selection'){
                  this.onImageSelected(this.$route.params.selectedFile);
                }
          }
            
        }
      }else{
        var queryForExistency = [];
        this.processedImagesResponse.forEach(element => {
          queryForExistency = queryForExistency + ',' + element.originalImageData.id;
        });

        this.checkIsFileExist(queryForExistency);
      }
    },

    checkIsFileExist(images){
      var _this = this;
        FileService.checkIsFileExist(images).then(
          response => {
            response.data.response.not_exist_list.forEach(element => {
              if(element !== "")
              {
                _this.processedImagesResponse.splice(_this.processedImagesResponse.findIndex(data => data.originalImageData.id == element), 1);
                _this.parsedList = JSON.stringify(_this.processedImagesResponse);
                localStorage.setItem('processedImages', _this.parsedList);
              }
            });

            _this.processedImages = _this.processedImagesResponse;

            if(_this.$route.params.method !== undefined)
            {
              if(_this.$route.params.selectedFile !== undefined)
              {
                if(_this.$route.params.method === 'drop')
                  {
                    _this.onDropFromHome(_this.$route.params.selectedFile);
                  }else if(_this.$route.params.method === 'selection'){
                    _this.onImageSelected(_this.$route.params.selectedFile);
                  }
              }
            }
          },
          error => {
            _this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
    },

    saveImage(newImage) {
      if (localStorage.getItem('processedImages')) {
        try {
          this.processedImages = JSON.parse(localStorage.getItem('processedImages'));
        } catch(e) {
          localStorage.removeItem('processedImages');
          this.processedImages = [];
        }
      }else{
        this.processedImages = [];
      }

      const parsed = newImage;
      this.processedImages.push(parsed);
      this.parsedList = JSON.stringify(this.processedImages);
      localStorage.setItem('processedImages', this.parsedList);
    },

    updateImage(updatedImage) {
      const parsed = updatedImage;
      this.processedImages[this.processedImages.findIndex(data => data.baseImageFileName === updatedImage.baseImageFileName)] = parsed;
      this.parsedList = JSON.stringify(this.processedImages);
      localStorage.setItem('processedImages', this.parsedList);
    },

    closeUpload(removedImage) {
      this.processedImages.splice(this.processedImages.findIndex(data => data.baseImageFileName === removedImage.baseImageFileName), 1);
      this.parsedList = JSON.stringify(this.processedImages);
      localStorage.setItem('processedImages', this.parsedList);
    },

    goToTermOfService() {
      this.$router.push('/term-of-service');
    }
  }
}
</script>
<style> 

</style>